import { Model } from '@models/core/base.model';

export const isSameModel = (a: Model, b: Model): boolean => {
    return a ? a.is(b) : false;
};
